import { FirebaseUser } from '../models/FirebaseModels';
import {
  Observable,
  from,
  of,
} from 'rxjs';
import {
  map,
  take,
} from 'rxjs/operators';

import { IChatMessage } from '@app/features/chat/models/chat';
import { ITicket } from '@app/shared/models/ticket';
import {Inject, Injectable} from '@angular/core';
import { environment } from '@environments/environment';
import { statusEnum } from '@app/shared/models/ticket';
import {ParseChatService} from "@shared/parse/parse-chat.service";
import {Utils} from "../../utils";
import * as utils from '@app/shared/utils/utils';
import {HttpClient} from "@angular/common/http";
import {Assistance} from "../../models/assistance";
import {AccountManagerService} from "../../services/account-manager-service";
import {RestApiManager} from "../../services/rest-api-manager";
import {CHAT_SERVICE} from "@app/services/injection-token";
import {IChatService} from "@app/services/ichat.service";

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(
    @Inject(CHAT_SERVICE) private internalChatService: IChatService,
    private httpClient: HttpClient,
    private parseService: ParseChatService,
    private restApiManager: RestApiManager,
    private accountManagerService: AccountManagerService,
  ) {}

  createOperationChatIfNotExits(operation: ITicket): Observable<any> {
    this.internalChatService.init(operation.id);
    return this.internalChatService.createOperationChatIfNotExits(operation);
  }

  joinChat(operation: ITicket, user: any): Observable<any> {
    this.internalChatService.init(operation.id);

    if (operation.status !== statusEnum.taken) {
      return of(null);
    }

    return this.createOperationChatIfNotExits(operation).pipe(
      take(1),
      map(() => {
        if (user) {
          const chatUser = new FirebaseUser(user);
          return this.internalChatService.joinChat(operation, chatUser);
        }
      })
    );
  }

  checkLastKeyValue(key: number): boolean {
    return this.internalChatService.lastKey !== key;
  }

  /**
   * TODO parse integration
   */
  getPaginationMessage() {
    /*const dbRef = this.db.list(this.messagesPath,
        (ref) => ref.orderByChild('sentAt').endAt(this.lastKey).limitToLast(this.perPage)
      );

    return dbRef.valueChanges().pipe(
      filter((messages) => messages.length > 0),
      map((messages: Array<IChatMessage>) => {
        messages.reverse();
        this.chatMessages = messages.reduce((old, newVal) => {
            return { [newVal.messageID]: newVal, ...old };
          }, this.chatMessages);

        return Object.values(this.chatMessages);
      })
    );*/
  }

  async getChatMessages(): Promise<Observable<Array<IChatMessage>>> {
    return this.internalChatService.getChatMessages();
  }

  async sendMessage(fromId: string, text: string, media?: any) {
    if (fromId) {
      return this.internalChatService.sendMessage(fromId, text, media);
    }
  }

  async setMessageDelivered(message: IChatMessage, userId: string) {

    /*console.log('message delivered');

    const deliveredMap = new Map<string, string>();
    deliveredMap[userId] = database.ServerValue.TIMESTAMP;

    const updateMap = {
      readAt : deliveredMap,
      deliveredAt : deliveredMap
    };

    await this.db.database.ref(this.messagesPath).child(message.messageID).update(updateMap);*/
  }

  saveAudio(file: any, operation: ITicket): Observable<object> {

    if (!file) {
      return;
    }

    const extension = '.' + utils.getFileExtension(file.title);

    const audioFile = new File([file.blob], file.title);
    const fileId = utils.getFileName(file.title);

    return from(Promise.all([
      this.uploadChatAttachment(audioFile),
      utils.getAudioDuration(file.blob),
    ])).pipe(
      map(([data, duration]: [any, number]) => {
        return {
          ...data,
          contentType: `audio/${extension}`,
          extension,
          duration: Math.round(duration * 1000)
        };
      })
    );

  }

  /*getFileMeta(file: any) {
    return from(this.firebaseService.getMediaMetaData(file));
  }*/

  /*uploadFile(files: FileList, filename: string): Observable<any> {
    console.log('Uploading file');
    return;
    return this.firebaseService.uploadFile(files, filename).snapshotChanges().pipe(
      filter((data) => data.metadata !== null),
      switchMap((data: any) => this.getFileMeta(data)),
      catchError((error) => throwError(error))
    );
  }*/

  async uploadChatAttachment(file: File) {

    const name = file.name.substring(0, file.name.lastIndexOf('.'));
    const extension = file.name.substring(file.name.lastIndexOf('.'));
    const fileId = name + '_' +  Utils.randomString(5);

    // Generate signed url from tilly server REST API
    const signedUrl = (await this.httpClient.get(`${environment.tilly.endpoint}/media/getUploadSignedUrl`, {
      params: {
        chatId: this.internalChatService.chatId,
        fileNameWithExtension: `${fileId}${extension}`,
        roomId: '100'
      }
    }).toPromise())['url'];

    // Upload file to bucket
    await this.httpClient.put(signedUrl, file).toPromise();

    // Get metadata
    return { id: fileId, name: `${name}${extension}`, size: file.size, contentType: file.type };

  }

  generateRoomName() {
    return Math.random().toString(36).substring(7);
  }

  /*getFileRef(path) {
    return this.firebaseService.getFileRef(path);
  }*/

  public async getChatMediaDownloadLink(chatId: string, mediaId: string, extension: string): Promise<string> {
    return (await this.httpClient.get(`${environment.tilly.endpoint}/media/getDownloadSignedUrl`, {
      params: {
        chatId: chatId,
        fileNameWithExtension: `${mediaId}.${extension}`,
        roomId: '100'
      }
    }).toPromise())['url'];
  }

  sendVideocallRequest(assistance: Assistance, operatorId: string, pin: string) {
    return this.internalChatService.sendVideocallRequest(assistance, operatorId, pin);
  }

  async closeChat(assistance: Assistance) {
    await this.restApiManager.post(
      `${environment.tilly.endpoint}/chat/ticket_${assistance.id}/room/100/close`,
      {},
      this.accountManagerService.account.authToken
    );
  }

}
